import React from 'react';
import { Download, User, Plane, Bus, Calendar, Phone } from 'lucide-react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import QRCode from 'react-qr-code';
import PDFDocument from '../DocumentPDF';

const Step3 = ({ formData, referenceNumber }) => {
    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 pb-4">
                <h2 className="text-xl font-bold text-[#287094] mb-2">
                    Récapitulatif de la demande {referenceNumber}
                </h2>
                <p className="text-sm text-gray-600">
                    Vérifiez toutes les informations avant de finaliser votre demande
                </p>
            </div>

            <div className="grid gap-6">
                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <div className="flex items-start gap-6">
                        <div className="w-16 h-16 flex-shrink-0">
                            <div className="w-full h-full bg-[#287094] bg-opacity-10 rounded-lg flex items-center justify-center">
                                <User className="w-8 h-8 text-[#287094]" />
                            </div>
                        </div>
                        <div className="flex-grow">
                            <h4 className="text-lg font-semibold text-[#287094] mb-4">INFORMATIONS PERSONNELLES</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <p className="text-sm text-gray-500">Type de Document</p>
                                    <p className="font-medium">{formData.document_voyage.type}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Numéro du Document</p>
                                    <p className="font-medium">{formData.document_voyage.numero}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Date d'Expiration</p>
                                    <p className="font-medium">{formData.document_voyage.date_expiration}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <div className="flex items-start gap-6">
                        <div className="w-16 h-16 flex-shrink-0">
                            <div className="w-full h-full bg-[#287094] bg-opacity-10 rounded-lg flex items-center justify-center">
                                {formData.type_voyage === 'aerien' ?
                                    <Plane className="w-8 h-8 text-[#287094]" /> :
                                    <Bus className="w-8 h-8 text-[#287094]" />
                                }
                            </div>
                        </div>
                        <div className="flex-grow">
                            <h4 className="text-lg font-semibold text-[#287094] mb-4">
                                {formData.type_voyage === 'aerien' ? 'INFORMATIONS DU VOL' : 'INFORMATIONS DU TRANSPORT'}
                            </h4>
                            <div className="grid grid-cols-2 gap-4">
                                {formData.type_voyage === 'aerien' ? (
                                    <>
                                        <div>
                                            <p className="text-sm text-gray-500">Compagnie Aérienne</p>
                                            <p className="font-medium">{formData.sejour.compagnie_aerienne}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Date du Vol</p>
                                            <p className="font-medium">{formData.sejour.date_vol}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Départ</p>
                                            <p className="font-medium">{formData.sejour.aeroport_depart}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Arrivée</p>
                                            <p className="font-medium">{formData.sejour.aeroport_arrivee}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Heure de Vol</p>
                                            <p className="font-medium">{formData.sejour.heure_vol}</p>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div>
                                            <p className="text-sm text-gray-500">Compagnie</p>
                                            <p className="font-medium">{formData.sejour.compagnie_terrestre}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Type de Véhicule</p>
                                            <p className="font-medium">{formData.sejour.type_vehicule}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Numéro du Véhicule</p>
                                            <p className="font-medium">{formData.sejour.numero_vehicule}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Date de Départ</p>
                                            <p className="font-medium">{formData.sejour.date_depart}</p>
                                        </div>
                                        <div>
                                            <p className="text-sm text-gray-500">Heure de Départ</p>
                                            <p className="font-medium">{formData.sejour.heure_depart}</p>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <div className="flex items-start gap-6">
                        <div className="w-16 h-16 flex-shrink-0">
                            <div className="w-full h-full bg-[#287094] bg-opacity-10 rounded-lg flex items-center justify-center">
                                <Calendar className="w-8 h-8 text-[#287094]" />
                            </div>
                        </div>
                        <div className="flex-grow">
                            <h4 className="text-lg font-semibold text-[#287094] mb-4">MOTIF ET DURÉE DU SÉJOUR</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <p className="text-sm text-gray-500">Motif du Voyage</p>
                                    <p className="font-medium">{formData.sejour.motif}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Durée du Séjour</p>
                                    <p className="font-medium">{formData.sejour.duree}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Ville de Destination</p>
                                    <p className="font-medium">{formData.sejour.ville_arrivee}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <div className="flex items-start gap-6">
                        <div className="w-16 h-16 flex-shrink-0">
                            <div className="w-full h-full bg-[#287094] bg-opacity-10 rounded-lg flex items-center justify-center">
                                <Phone className="w-8 h-8 text-[#287094]" />
                            </div>
                        </div>
                        <div className="flex-grow">
                            <h4 className="text-lg font-semibold text-[#287094] mb-4">CONTACT D'URGENCE</h4>
                            <div className="grid grid-cols-2 gap-4">
                                <div>
                                    <p className="text-sm text-gray-500">Nom Complet</p>
                                    <p className="font-medium">
                                        {`${formData.contact_urgence?.nom || ''} ${formData.contact_urgence?.prenom || ''}`}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Lien</p>
                                    <p className="font-medium">{formData.contact_urgence?.lien || 'Non renseigné'}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Téléphone</p>
                                    <p className="font-medium">{formData.contact_urgence?.telephone || 'Non renseigné'}</p>
                                </div>
                                <div>
                                    <p className="text-sm text-gray-500">Email</p>
                                    <p className="font-medium">{formData.contact_urgence?.email || 'Non renseigné'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-100">
                    <div className="flex flex-col items-center gap-4">
                        <QRCode
                            value={JSON.stringify({
                                reference: referenceNumber,
                                type: formData.type_voyage,
                                document: formData.document_voyage.type,
                                numero: formData.document_voyage.numero
                            })}
                            level="H"
                            size={200}
                        />
                    </div>
                </div>
            </div>

            <div className="flex justify-between mt-8">
                <div className="flex gap-4">
                    <PDFDownloadLink
                        document={<PDFDocument formData={formData} referenceNumber={referenceNumber} />}
                        fileName={`voyage-${referenceNumber}.pdf`}
                        className="px-6 py-2 bg-[#96B734] text-white rounded-lg hover:bg-opacity-90 flex items-center"
                    >
                        {({ loading }) => (
                            <>
                                <Download className="w-5 h-5 mr-2" />
                                {loading ? "Génération..." : "Télécharger PDF"}
                            </>
                        )}
                    </PDFDownloadLink>
                </div>
            </div>
        </div>
    );
};

export default Step3;
